module.exports = __webpack_public_path__ + "img/belgium-liver-cancer-male.e5681e7b.png";